import { format, parse } from 'date-fns';

import { DATE_FORMAT } from '~/utils/consts';

const EMPTY_VALUE = '';

type tFormatDate = (
  value: string | Date,
  f: string | {
    in: string;
    out: string;
  },
  emptyValue: string,
) => string;

const formatDate: tFormatDate = (
  value,
  f = DATE_FORMAT,
  emptyValue = EMPTY_VALUE,
) => {
  if (!value) return emptyValue;

  if (typeof f === 'string') {
    /* eslint-disable-next-line no-param-reassign */
    f = {
      in: DATE_FORMAT,
      out: f,
    };
  }

  /* eslint-disable-next-line no-param-reassign */
  if (!f.out) f.out = DATE_FORMAT;

  if (value instanceof Date) {
    return format(value, f.out);
  }

  return format(parse(value), f.out);
};

export default formatDate;
